module.exports = __webpack_public_path__ + "img/d63ccce.jpg";